import { Form, Record } from '3map-models';

export type TableData = {
  dataset: { formId: string; specificIds: string[]; showHistory: boolean };
  records: Record[];
  form: Form;
  username: string;
  role: 'ADMIN' | 'MOD' | 'USER';
};
